import React from 'react';
import ReactPlayer from 'react-player';
import {Col, Row, Container} from "react-bootstrap";
import './styles.css';

const Music = () => {
    const tracks = [
        {
            title: "Yesterday",
            url: "https://soundcloud.com/hidanko/yesterday",
        },
        {
            title: "Ondas",
            url: "https://soundcloud.com/hidanko/ondas",
        },
        {
            title: "Cloudy Nights",
            url: "https://soundcloud.com/hidanko/cloudy-nights",
        },
        {
            title: "Luzes",
            url: "https://soundcloud.com/hidanko/luzes",
        },
        {
            title: "Twilight",
            url: "https://soundcloud.com/hidanko/twilight",
        },
        {
            title: "Giz",
            url: "https://soundcloud.com/hidanko/giz",
        }
    ];

    return (
        <div className="content">
            <Container className="music-page py-5">
                <div className="text-center mb-5">
                    <h1 className="display-4 mb-3">Music</h1>
                </div>
                
                <Row className="g-4">
                    {tracks.map((track, index) => (
                        <Col key={index} md={6} lg={4}>
                            <div className="track-card">
                                <div className="player-wrapper">
                                    <ReactPlayer
                                        url={track.url}
                                        controls
                                        width="100%"
                                        height="166px"
                                        className="soundcloud-player"
                                    />
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </div>
    );
};

export default Music;